export var DevelopmentTool;
(function (DevelopmentTool) {
    DevelopmentTool["UNKNOWN_TEMPLATE_TYPE"] = "UNKNOWN_TEMPLATE_TYPE";
    DevelopmentTool["DEV_CENTER"] = "DEV_CENTER";
    DevelopmentTool["BLOCKS"] = "BLOCKS";
    DevelopmentTool["CLI"] = "CLI";
})(DevelopmentTool || (DevelopmentTool = {}));
export var PackageManager;
(function (PackageManager) {
    PackageManager["UNKNOWN_PACKAGE_MANAGER"] = "UNKNOWN_PACKAGE_MANAGER";
    PackageManager["NPM"] = "NPM";
    PackageManager["YARN"] = "YARN";
})(PackageManager || (PackageManager = {}));
export var DeploymentHostType;
(function (DeploymentHostType) {
    DeploymentHostType["UNKNOWN_DEPLOYMENT_HOST_TYPE"] = "UNKNOWN_DEPLOYMENT_HOST_TYPE";
    DeploymentHostType["VERCEL"] = "VERCEL";
    DeploymentHostType["NETLIFY"] = "NETLIFY";
})(DeploymentHostType || (DeploymentHostType = {}));
export var NamespaceType;
(function (NamespaceType) {
    NamespaceType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    NamespaceType["ACCOUNT"] = "ACCOUNT";
    NamespaceType["COMPANY"] = "COMPANY";
})(NamespaceType || (NamespaceType = {}));
export var Status;
(function (Status) {
    Status["ACTIVE"] = "ACTIVE";
    Status["DEPRECATED"] = "DEPRECATED";
    Status["ARCHIVED"] = "ARCHIVED";
})(Status || (Status = {}));
export var AppType;
(function (AppType) {
    /** A Regular app entity - used to installed on sites */
    AppType["SITE_APP"] = "SITE_APP";
    /** represents an account API KEY to access wix services */
    AppType["API_KEY"] = "API_KEY";
    /** represents an app developed for Velo editor */
    AppType["VELO_APP"] = "VELO_APP";
    /** deprecated. Use private boolean instead */
    AppType["PRIVATE_APP"] = "PRIVATE_APP";
    /** represents an External Headless (3rd party) App that has access to Wix Public Services */
    AppType["HEADLESS"] = "HEADLESS";
    /** represents an app specific to a Meta Site that stores data about Activated Functions in that Meta Site */
    AppType["FUNCTION_ACTIVATION_APP"] = "FUNCTION_ACTIVATION_APP";
})(AppType || (AppType = {}));
export var CreatedByType;
(function (CreatedByType) {
    CreatedByType["USER"] = "USER";
    CreatedByType["APP"] = "APP";
})(CreatedByType || (CreatedByType = {}));
export var ShowConsentBehaviour;
(function (ShowConsentBehaviour) {
    ShowConsentBehaviour["DEFAULT_BEHAVIOUR"] = "DEFAULT_BEHAVIOUR";
    ShowConsentBehaviour["SHOW_CONSENT"] = "SHOW_CONSENT";
    ShowConsentBehaviour["SKIP_CONSENT"] = "SKIP_CONSENT";
})(ShowConsentBehaviour || (ShowConsentBehaviour = {}));
export var RedirectTarget;
(function (RedirectTarget) {
    RedirectTarget["UNKNOWN_REDIRECT_TARGET"] = "UNKNOWN_REDIRECT_TARGET";
    RedirectTarget["DASHBOARD"] = "DASHBOARD";
    RedirectTarget["EDITOR"] = "EDITOR";
})(RedirectTarget || (RedirectTarget = {}));
export var OpenButtonAction;
(function (OpenButtonAction) {
    OpenButtonAction["UNKNOWN_ACTION"] = "UNKNOWN_ACTION";
    OpenButtonAction["OPEN_COMPONENT_ID"] = "OPEN_COMPONENT_ID";
})(OpenButtonAction || (OpenButtonAction = {}));
//# sourceMappingURL=types.impl.js.map